// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2nCOe","info":"UpdateTermsInfo_info__39i9n"};